// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1Hm-s","errors":"Errors_errors__6lXV8"};